import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initializeAnalytics } from '../utils/analytics';
import { trackPageView as trackHubSpotPageView } from '../services/hubspotService';

/**
 * Hook to automatically track page views on route changes
 */
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize analytics on mount
    initializeAnalytics();
  }, []);

  useEffect(() => {
    // Track page view on route change
    const path = location.pathname + location.search;

    // Track in Google Tag Manager
    trackPageView(path);

    // Track in HubSpot
    trackHubSpotPageView(path);
  }, [location]);
};
